:host {
  --padding: var(--sportsline-pick-snippet-card-padding, 0.75rem);
  --team-color: var(--sportsline-pick-snippet-card-team-color, #c2c2c2);
  --border-radius: var(--sportsline-pick-snippet-card-border-radius, 0.5rem);
  --card-color-width: var(--sportsline-pick-snippet-card-color-width, 0.375rem);
  font-family: 'FS Industrie', FSIndustrie-Bold, industrie-standard, Helvetica, Arial, sans-serif;
  display: flex;
  width: 100%;
  background-color: var(--Background-Color, #fff);
  color: var(--Text-Primary, #202121);
  padding: var(--padding);
  align-items: center;
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.1);
  border-radius: var(--border-radius);
  position: relative;

  &,
  & > * {
    box-sizing: border-box;
  }
}

.sportsline-pick-snippet-card {
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 0.75rem;
  font-family: 'FS Industrie', 'FSIndustrie-Bold', 'industrie-standard', Helvetica, Arial, sans-serif;
}

.sportsline-pick-snippet-card__team-color {
  min-height: 100%;
  background-color: var(--sportsline-pick-snippet-card-team-color);
  border-radius: 0 var(--card-color-width) var(--card-color-width) 0;
  width: var(--card-color-width);
  min-width: var(--card-color-width);
}

.sportsline-pick-snippet-card__content-wrapper {
  display: flex;
  gap: var(--padding);
  width: fit-content;
}

.sportsline-pick-snippet-card__content {
  display: flex;
  align-items: center;
  gap: var(--padding);
}

.sportsline-pick-snippet-card__pick-details {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.sportsline-pick-snippet-card__pick-label {
  color: var(--Text-Primary, #202121);
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 120%;
  letter-spacing: -0.72px;
  text-wrap: pretty;
}

.sportsline-pick-snippet-card__pick-label--odds {
  color: var(--Text-Tertiary, #767676);
  font-size: 1rem;
  font-style: normal;
  font-weight: 500;
  line-height: 120%;
  vertical-align: middle;
  margin-left: 0.5rem;
}

.sportsline-pick-snippet-card__market {
  font-size: 0.875rem;
  font-style: normal;
  font-weight: 700;
  line-height: 1.2;
  text-transform: capitalize;

  > span:not(:first-child) {
    line-height: 1;
    margin-left: 0.5ch;
  }
}

.sportsline-pick-snippet-card__metadata {
  font-size: 0.75rem;
  font-style: normal;
  font-weight: 500;
  line-height: 1;
  text-transform: uppercase;

  color: var(--Text-Tertiary, #767676);
  font-style: normal;
}

.sportsline-pick-snippet-card__actions {
  margin-left: auto;
  width: 100%;
  &:empty {
    display: none;
  }
}

@media screen and (min-width: 768px) {
  :host {
    padding-left: 0;
    padding-right: 1rem;
    flex-direction: row;
  }
  .sportsline-pick-snippet-card {
    flex-direction: row;
    align-items: center;
  }
  .sportsline-pick-snippet-card__actions {
    width: fit-content;
  }
}
